/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * Helper function to get the item action context from row information
 */
export const getActionContext = <K extends string | number, D>(index: number, key: K, data: D) => {
  return { metadata: { key }, data, index };
};
